import './App.css';
import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { auth } from './firebaseConfig';
import { onAuthStateChanged } from 'firebase/auth';
import { Toaster } from 'react-hot-toast';
import HomePage from './pages/HomePage';
import Portfolio from './components/Portfolio';
import Register from './components/Sign';
import ScrollToTop from './components/ScrollToTop';
import IndiaUntamedPage from './pages/IndiaUntamedPage';
import EatPrayLovePage from './pages/EatPrayLovePage';
import AsiaWonderlustPage from './pages/AsiaWonderlustPage';
import OdeToTheArtsPage from './pages/OdeToTheArtsPage';
import ClubDetail from './components/ClubDetail';
import ExperiencePage from './pages/ExperiencePage';
import CollectionsPage from './pages/CollectionsPage';
import OurStoryPage from './pages/OurStoryPage';
import InvestOwnPage from './pages/InvestOwnPage';
import Terms from './components/Terms';
import Privacy from './components/Privacy';
import OwnerLogin from './dashboards/owner-dashboard/OwnerLogin';
import Signup from './components/SignUp';
import UserLogin from './components/UserLogin';
import MemberLogin from './dashboards/member-dashboard/MemberLogin';
import AdminLogin from './dashboards/admin-dashboard/AdminLogin';
import AdminDashboard from './dashboards/admin-dashboard/AdminDashboard';
import ProtectedRoute from './components/ProtectedRoute';
import ProtectedRouteMember from './components/ProtectedRoute/member';
import ProtectedRouteAdmin from './components/ProtectedRoute/admin';
import VillaList from './components/VillaList';
import VillaDetail from './components/VillaDetail';
import OwnerDashboard from './dashboards/owner-dashboard/OwnerDashboard';
import Dashboard from './dashboards/owner-dashboard/Dashboard';
import MyVillas from './dashboards/owner-dashboard/MyVillas';
import Bookings from './dashboards/owner-dashboard/Bookings';
import ServiceRequests from './dashboards/owner-dashboard/Service';
import AddProperty from './components/AddProperty';
import FinanceAnalytics from './dashboards/owner-dashboard/Finance';
import Settings from './dashboards/owner-dashboard/Settings';
import MemberDashboard from './dashboards/member-dashboard/MemberDashboard';
import DashboardMember from './dashboards/member-dashboard/DashboardMember';
import MemberVillas from './dashboards/member-dashboard/MemberVillas';
import BookingsMember from './dashboards/member-dashboard/BookingsMember';
import MemberServices from './dashboards/member-dashboard/MemberServices';
import MemberSettings from './dashboards/member-dashboard/MemberSettings';
import MyBookings from './components/UserBookings';
import VillaAvailability from './components/VillaAvailability';
import BookingConfirm from './components/BookingConfirm';
import UpdateServices from './components/UpdateServices';
import UpdateProfile from './components/UdateInfo';
import ChangeLogin from './components/ChangeLogin';
import Debug from './components/Debug';
import AboutMembershipPage from './pages/AboutMembershipPage';
import LifestyleInvestmentsPage from './pages/LifestyleInvestmentsPage';
import InvitationForm from './components/InvitationForm';
import VillaError from './components/VillaError';

function App() {
  const [bookings, setBookings] = useState([]);
  const [cancellations, setCancellations] = useState([]);
  const [ownerId, setOwnerId] = useState(null);
  const [memberId, setMemberId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    try {
      const unsubscribe = onAuthStateChanged(auth, (user) => {
        try {
          if (user) {
            setOwnerId(user.uid);
            setMemberId(user.uid);
          } else {
            setOwnerId(null);
            setMemberId(null);
          }
          setLoading(false);
        } catch (err) {
          console.error('Error in auth state change:', err);
          setError(err.message);
          setLoading(false);
        }
      });
      return () => unsubscribe();
    } catch (err) {
      console.error('Error setting up auth listener:', err);
      setError(err.message);
      setLoading(false);
    }
  }, []);

  if (error) {
    return (
      <div style={{ padding: '20px', textAlign: 'center', marginTop: '50px' }}>
        <h2>⚠️ Error Loading Application</h2>
        <p>{error}</p>
        <p style={{ fontSize: '12px', color: '#666' }}>Please check the browser console for more details.</p>
      </div>
    );
  }

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        height: '100vh',
        background: '#faf8f5'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{
            width: '50px',
            height: '50px',
            border: '4px solid #f3f3f3',
            borderTop: '4px solid #b07d3a',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 20px'
          }}></div>
          <p style={{ fontFamily: 'Josefin Sans, sans-serif', color: '#666' }}>Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <Router>
      <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: '#333',
            color: '#fff',
            fontSize: '16px',
            padding: '12px',
            borderRadius: '8px',
            fontFamily: "Josefin Sans",
          },
          success: {
            duration: 4000,
            iconTheme: {
              primary: '#0f0',
              secondary: '#fff',
            },
          },
          error: {
            duration: 4000,
            iconTheme: {
              primary: '#f00',
              secondary: '#fff',
            },
          },
        }}
      />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<Portfolio />} />
        <Route path="/debug" element={<Debug />} />
        <Route path="/the-club" element={<ClubDetail />} />
        <Route path="/our-services" element={<ExperiencePage />} />
        <Route path="/our-collections" element={<CollectionsPage />} />
        <Route path="/our-story" element={<OurStoryPage />} />
        <Route path="/owner-login" element={<OwnerLogin />} />
        <Route path="/user-login" element={<UserLogin />} />
        <Route path="/villa" element={<VillaList />} />
        <Route path="/villa/:slug" element={<VillaDetail />} />
        <Route path="/villa/:slug/booking" element={<BookingConfirm />} />
        <Route path="/member-login" element={<MemberLogin />} />
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/invest-own" element={<InvestOwnPage />} />
        <Route path="/terms-conditions" element={<Terms />} />
        <Route path="/privacy-policy" element={<Privacy />} />
        <Route path="/register" element={<Register />} />
        <Route path="/india-untamed" element={<IndiaUntamedPage />} />
        <Route path="/eat-pray-love" element={<EatPrayLovePage />} />
        <Route path="/asia-wonderlust" element={<AsiaWonderlustPage />} />
        <Route path="/ode-to-the-arts" element={<OdeToTheArtsPage />} />
        <Route path="/my-bookings" element={<MyBookings />} />
        <Route
          path="/owner-dashboard"
          element={
            <ProtectedRoute>
              <OwnerDashboard
                bookings={bookings}
                setBookings={setBookings}
                cancellations={cancellations}
                setCancellations={setCancellations}
                ownerId={ownerId}
              />
            </ProtectedRoute>
          }
        >
          <Route index element={<Dashboard ownerId={ownerId} />} />
          <Route path="villas" element={<MyVillas setBookings={setBookings} ownerId={ownerId} />} />
          <Route
            path="bookings"
            element={
              <Bookings
                bookings={bookings}
                cancellations={cancellations}
                setCancellations={setCancellations}
                ownerId={ownerId}
              />
            }
          />
          <Route path="services" element={<ServiceRequests />} />
          <Route path="finance" element={<FinanceAnalytics />} />
          <Route path="settings" element={<Settings />} />
          <Route path="settings/profile" element={<UpdateProfile />} />
          <Route path="settings/password" element={<ChangeLogin />} />
        </Route>
        
        <Route
          path="/member-dashboard"
          element={
            <ProtectedRouteMember>
              <MemberDashboard
                bookings={bookings}
                setBookings={setBookings}
                cancellations={cancellations}
                setCancellations={setCancellations}
                memberId={memberId}
              />
            </ProtectedRouteMember>
          }
        >
          <Route index element={<DashboardMember memberId={memberId} />} />
          <Route path="villas" element={<MemberVillas setBookings={setBookings} memberId={memberId} />} />
          <Route
            path="bookings"
            element={
              <BookingsMember
                bookings={bookings}
                cancellations={cancellations}
                setCancellations={setCancellations}
                memberId={memberId}
              />
            }
          />
          <Route path="services" element={<MemberServices />} />
          <Route path="settings" element={<MemberSettings />} />
          <Route path="settings/profile" element={<UpdateProfile />} />
          <Route path="settings/password" element={<ChangeLogin />} />
        </Route>
        <Route
          path="/admin-dashboard"
          element={
            <ProtectedRouteAdmin>
              <AdminDashboard
                bookings={bookings}
                setBookings={setBookings}
                cancellations={cancellations}
                setCancellations={setCancellations}
              />
            </ProtectedRouteAdmin>
          }
        >
          <Route index element={<Signup />} />
          <Route path="villas" element={<VillaList />} />
          <Route
            path="bookings"
            element={
              <Bookings
                bookings={bookings}
                cancellations={cancellations}
                setCancellations={setCancellations}
              />
            }
          />
          <Route path="availability" element={<VillaAvailability bookings={bookings} cancellations={cancellations} setCancellations={setCancellations} />} />
          <Route path="services" element={<UpdateServices />} />
          <Route path="property" element={<AddProperty />} />
          <Route path="users" element={<Signup />} />
        </Route>
        <Route path="/about-membership" element={<AboutMembershipPage />} />
        <Route path="/invitation-form" element={<InvitationForm />} />
        <Route path="/lifestyle-investments" element={<LifestyleInvestmentsPage />} />
        <Route path="*" element={<VillaError />} />
      </Routes>
    </Router>
  );
}

export default App;